<style scoped lang="sass">
.mask_floor
  position: fixed
  top: 0
  left: 0
  right: 0
  bottom: 0
  display: flex
  flex-direction: column
  align-items: center
  background-color: rgba(0, 0, 0, .77)
  color: #fff
  z-index: 2

  .title
    font-size: 21px
    line-height: 21px

  .description
    margin-top: 10px
    padding: 0 50px
    font-size: 15px
    line-height: 17px
    text-align: center

  .got_it
    margin-top: 20px
    height: 38px
    border: none
    border-radius: 4px
    background-color: var(--menu-primary-background-colour)
    font-size: 15px
    text-align: center
    color: #fff
    border-radius: 5px !important

  .icon_border
    display: flex
    align-items: center
    justify-content: center
    width: 60px
    height: 60px
    border: 1px solid #fff
    border-radius: 100%

    .icon_bgc
      display: flex
      align-items: center
      justify-content: center
      width: 45px
      height: 45px
      border-radius: 100%
      background-color: var(--menu-header-background-colour)
</style>
<style lang="sass" scoped>

.top
  align-self: flex-start
  height: 160PX
  margin-bottom: 30PX

.title
  margin-top: -10px

.img
  height: 100%

</style>

<template lang="pug">
.mask_floor(v-if="showMask")
  .top
    img.img(:src="leftArrowSrc")
  span.title {{ manageTitle }}
  p.description {{ manageTabText }}
  van-button.got_it.ls3(@click="clickButton") GOT IT
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  props: {
    showMask: {
      type: Boolean,
      default: true
    },

    manageTitle: {
      type: String,
      default: 'Manage your tab'
    },

    manageTabText: {
      type: String,
      default: 'Select ‘Manage my tab’ from the menu to see your balance, increase, share or close your tab.'
    }
  }
})

class MaskManageTab extends Vue {
  leftArrowSrc = require('@/assets/venue-home-mask/left-arrow.png')

  clickButton() {
    this.$emit('update:showMask', false)
    // localStorage.setItem('showMask', 'unShow')
  }
}

export default MaskManageTab
</script>
